<template>
  <div class="admin-field-multiselect" @click="isFocused = true">
    <AdminInputMultiselect
      v-bind="{ ...$attrs, ...$props }"
      @keydown.esc="$emit('change', value)"
      @change="$emit('change', $event)"
      @blur="isFocused = false"
      :value="value"
      :search-input.sync="search"
      @keydown.delete="deleteHandler"
      :is-focused="isFocused"
    />
  </div>
</template>

<script>
import AdminInputMultiselect from '@/components/AdminInputMultiselect'
export default {
  name: 'AdminFieldMultiselect',
  components: { AdminInputMultiselect },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFocused: false,
      search: '',
    }
  },
  methods: {
    deleteHandler() {
      if (!this.search || !this.search.length) {
        let updatedSelection = [...this.value]
        updatedSelection.pop()
        this.$emit('change', updatedSelection)
      }
    }, // deleteHandler
  },
}
</script>

<style scoped>
.admin-field-multiselect {
  cursor: pointer;
}
</style>
